import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  styles: {
    global: {
      // styles for the `body`
      body: {
        bg: "#ededed", //for the background color
        color: "black", //for the text color
      },
    },
  },

  components: {
    //set a default color for all buttons
    Button: {
      variants: {
        solid: {
          bg: "brand.500",
          color: "white",
          _hover: {
            bg: "brand.600",
          },
          _active: {
            bg: "brand.700",
          },

          _focus: {
            boxShadow: "none",
          },
        },
      },
    },
    Input: {
      variants: {
        outline: {
          field: {
            _focus: {
              bgColor: "brand.50",
              borderColor: "brand.500",
              boxShadow: "none",
            },
          },
        },
      },
    },
  },

  colors: {
    brand: {
      50: "#e6eaf7",
      100: "#bcc7e8",
      200: "#8fa1d7",
      300: "#627bc6",
      400: "#4260b9",
      500: "#001756", // Primary brand color
      600: "#001540",
      700: "#00122a",
      800: "#000f1f",
      900: "#000a14",
    },
  },
});

export default theme;
